import PackageProcessIcon from "@hugeicons/core-free-icons/PackageProcessIcon";
import Invoice01Icon from "@hugeicons/core-free-icons/Invoice01Icon";
import DeliveryReturn01Icon from "@hugeicons/core-free-icons/DeliveryReturn01Icon";
import Cash01Icon from "@hugeicons/core-free-icons/Cash01Icon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import { FINANCE_ROLES } from "../constants/roles";

// Finance Console nav (`.scratch/finance-dashboard/IMPLEMENTATION.md`).
//
// Its own top-level console at /v2/finance/*, not a section of the pharmacist console:
// the four tabs read order/payment/quotation data for a different audience and a
// different task (reconciliation, not fulfilment).
//
// Four sidebar entries rather than one entry plus an in-page tab strip, because these
// are four peer views with no landing screen above them — unlike Procurement, whose
// purchase-order pages hang off a single workflow.
//
// ROLES: FINANCE_ROLES. Was a PHARMACY_ROLES placeholder carried over from the previous mount. §6 of the
// spec explicitly defers the access-control decision, and promoting Finance to its own
// console makes that question sharper, not softer — a finance team that is not the
// pharmacy team will need its own role. Flagged, not resolved.
export const FINANCE_NAV = [
    { key: "orders", label: "Orders", path: "/v2/finance/orders", icon: PackageProcessIcon, roles: FINANCE_ROLES },
    { key: "quotations", label: "Quotations", path: "/v2/finance/quotations", icon: Invoice01Icon, roles: FINANCE_ROLES },
    { key: "refunds", label: "Refunds", path: "/v2/finance/refunds", icon: DeliveryReturn01Icon, roles: FINANCE_ROLES },
    { key: "cod", label: "COD", path: "/v2/finance/cod", icon: Cash01Icon, roles: FINANCE_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/finance/users", icon: UserMultipleIcon, roles: FINANCE_ROLES },
];
